<template lang="html">
	<div class="common-mar-b">
		<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" :immediate-check="immediateCheck">
			<van-swipe :autoplay="2000" class="index-swipe">
				<van-swipe-item v-for="(item, index) in banner" :key="index">
					<a :href="item.ban_link">
						<van-image class="index-swipe-img" fit="cover" :src="bannerUrl+item.ban_image" />
					</a>
				</van-swipe-item>
			</van-swipe>
			<van-row class="common-title">
				<van-col span="24">
					<div class="fl">推荐直播</div>
					<van-image class="fr common-more" src="../../../static/images/gengduo.png" @click="goOnlives()" />
				</van-col>
			</van-row>
			<van-row class="recommend-live" v-if="live != null">
				<van-col span="24">
					<!-- 直播预告 -->
					<!-- <div class="live-top-shade">
						<van-image class="live-statu-img" src="../../../static/images/zhiboyugao.png" />
						<div class="fix live-time">
							<div class="fl">距直播</div>
							<div class="fl time-day">20</div>
							<div class="fl time-text">天</div>
							<div class="fl time-hour">20</div>
							<div class="fl time-target">:</div>
							<div class="fl time-minute">20</div>
							<div class="fl time-target">:</div>
							<div class="fl time-second">20</div>
						</div>
					</div> -->
					<!-- 直播预告 -->
					<!-- 直播中 -->
					<!-- <div class="live-statu-ing">
						<van-image class="live-statu-ingicon" src="../../../static/images/zhibozhong.png" />
						<div class="inlive-count">20人在线</div>
					</div> -->
					<!-- 直播中 -->
					<!-- 直播回放 -->
					<!-- <div class="live-statu-back">
						<van-image class="live-statu-backicon" src="../../../static/images/zhibohuifang.png" />
						<div class="inlive-count">2056人观看</div>
					</div> -->
					<!-- 直播回放 -->
					<div class="live-container" v-for="(item, index) in live" :key="index" @click="goLiveDetail(item.id)">
						<div class="live-top-infos">
							<van-image class="live-bg-img" :src="bannerUrl+item.live_banner_image" />
						</div>
						<div class="live-bottom-title">{{item.live_title}}</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="common-title">
				<van-col span="24">
					<div class="fl">推荐课程</div>
					<van-image class="fr common-more" src="../../../static/images/gengduo.png" @click="goCourses()" />
				</van-col>
			</van-row>
			<van-row class="recommend-course">
				<van-col span="24">
					<div class="course-container">
						<div class="fl course-item" v-for="(item, index) in course" :key="index" @click="goCourseDetail(item.id)">
							<div class="course-image-box">
								<van-image class="course-image" it="cover" :src="bannerUrl+item.course_thumbnail_image" />
								<div class="course-count"><div class="course-count-icon">{{item.course_buy_num}}</div></div>
							</div>
							<div class="course-title">{{item.course_title}}</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="common-title">
				<van-col span="24">
					<div class="fl">推荐视频</div>
					<van-image class="fr common-more" src="../../../static/images/gengduo.png" @click="goVideos()" />
				</van-col>
			</van-row>
			<van-row class="recommend-video">
				<van-col span="24">
					<div class="video-item" v-for="(item, index) in video" :key="index" @click="goVideoDetail(item.id)">
						<div class="video-image-box">
							<van-image class="video-image" fit="cover" :src="bannerUrl+item.video_thumbnail_image" />
						</div>
						<div class="video-title">{{item.video_title}}</div>
						<div class="fix video-statu">
							<div class="fl">共{{item.subsection_count}}节</div>
							<div class="fr">{{item.video_browse_num}}观看</div>
						</div>
					</div>	
				</van-col>
			</van-row>
        </van-list>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
	import FooterNav from "../../components/footer.vue"
	import { Swipe, SwipeItem } from 'vant'
	export default{
		components:{
			FooterNav,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem
		},
		data(){
			return {
				bannerUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				banner: [],
				course: [],
				video: [],
				live: [],
				loading: false, //控制上拉加载的加载动画
				finished: false, //控制在页面往下移动到底部时是否调用接口获取数据
				totalPage: 0,
				pageNumber: 1,
				immediateCheck: false //是否在初始化时立即执行滚动位置检查
			}
		},
		created(){
			document.title = "读联"
			let that = this
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdataIndex = new FormData();
			formdataIndex.append('token', localStorage.getItem('token'))
			that.$axios.post('http://sls.zhishen.net.cn/api/Index/index', formdataIndex)
			.then(function (res) {
				res.data.banner.forEach(function(item){
					let urlStr = item.ban_link.split( "#/" )
					let newUrl = urlStr[0] + urlStr[1]
					that.banner.push({
						'ban_link': newUrl,
						'ban_image': item.ban_image
					}) 
				})
				that.course = res.data.course_list;
				that.video = res.data.video.video_list;
				that.live = res.data.live;
			})
			.catch(function (error) {
				console.log(error);
			});
		},
		methods:{
			//上拉加载
			onLoad() {
				let that = this;
				setTimeout(() => {
					let formdata = new FormData();
					formdata.append('token', localStorage.getItem('token'))
					formdata.append('page', that.pageNumber + 1);
					that.$axios.post('http://sls.zhishen.net.cn/api/Index/getVideoList', formdata).then(function (res) {
						that.totalPage = res.data.total_page
						if (that.pageNumber >= that.totalPage) {
							that.finished = true;
							that.loading = false;
						}else{
							that.video = that.video.concat(res.data.video)
							that.loading = false;
							that.pageNumber++;
						}
					}).catch(function (error) {
						console.log(error);
					})
				}, 500);
			},
			//推荐课程-更多
			goCourses(){
				window.location.href = this.login.pageUrl + '/live';
			},
			//点击进入课程详情
			goCourseDetail(id){
				window.location.href = this.login.pageUrl + '/coursedetail?courseId=' + id;
				//this.$router.push({path: '/coursedetail'});
			},
			//推荐视频-更多
			goVideos(){
				window.location.href = this.login.pageUrl + '/video';
			},
			//点击进入视频详情
			goVideoDetail(id){
				window.location.href = this.login.pageUrl + '/videodetail?videoId=' + id;
			},
			//推荐直播-更多
			goOnlives(){
				window.location.href = this.login.pageUrl + '/onlive';
				//this.$router.push({path: '/onlive'});
			},
			//点击进入直播详情
			goLiveDetail(id){
				window.location.href = this.login.pageUrl + '/onlivedetail?liveId=' + id;
				//this.$router.push({path: '/onlivedetail'});
			}
		}
	}
</script>

<style lang="css" scoped>
	.index-swipe{padding-top: 4vw;height: 40vw;}
	.common-title,.recommend-video{width: 89.34vw;}
	.common-title,.course-title{line-height: 4.8vw;}
	.common-title{margin: 29px auto 0 auto;font-size: 4.8vw;}
	.common-more{width: 13.07vw;height: 2.94vw;margin-top: 0.93vw;}
	.recommend-video{margin: 0 auto;}
	.video-item{height: 62.67vw;box-shadow: 0px 1px 16px 0px rgba(5,5,5,0.08);margin-top: 20px;border-radius: 2.67vw;}
	.video-image{border-radius: 2.67vw 2.67vw 0px 0px;}
	.video-title,.live-bottom-title,.time-day,.time-hour,.time-minute,.time-second{font-weight: bold;}
	.video-title,.live-bottom-title{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
	.video-title{padding: 4vw 4.27vw;line-height: 4.27vw;}
	.video-statu{line-height: 3.74vw;color: #666;font-size: 3.74vw;padding: 0 4.27vw;}
	.recommend-live{margin-top: 5.33vw;white-space: nowrap;overflow: auto;-webkit-overflow-scrolling : touch;}
	.live-container{width: 89.34vw;height: 61.33vw;margin-left: 5.33vw;margin-bottom: 2px;box-shadow: 0px 1px 16px 0px rgba(5,5,5,0.08);border-radius: 2.66vw;display: inline-block;}
	.recommend-live .live-container:last-child{margin-right: 5.33vw;}
	.live-top-infos,.live-bg-img,.live-top-shade{width: 100%;height: 48vw;}
	.live-top-infos{position: relative;}
	.live-top-shade,.live-statu-img,.live-time,.live-statu-ing,.live-statu-ingicon,.live-statu-back,.live-statu-backicon{position: absolute;}
	.live-top-shade{top: 0;left: 0;background: url(../../../static/images/shipinzhezhao.png) no-repeat left;}
	.live-statu-img,.live-statu-ing,.live-statu-back{top: 2.4vw;left: 2.4vw;}
	.live-statu-img,.live-statu-ing,.live-statu-ingicon,.live-statu-back,.live-statu-backicon{height: 5.6vw;}
	.live-statu-img{width: 15.2vw;}
	.inlive-count,.live-time{color: #fff;}
	.live-statu-ing,.live-statu-back{font-size: 3.2vw;background: rgba(0,0,0,0.2);border-radius: 2.93vw;line-height: 5.6vw;}
	.live-statu-ing{padding: 0 2.13vw 0 8.8vw;}
	.live-statu-back{padding: 0 2.13vw 0 16.26vw;}
	.live-statu-ingicon,.live-statu-backicon{top: 0;left: 0;}
	.live-statu-ingicon{width: 7.46vw;}
	.live-statu-backicon{width: 14.93vw;}
	.live-time,.time-day,.time-hour,.time-minute,.time-second{font-size: 3.47vw;}
	.live-time{line-height: 8.8vw;left: 4vw;bottom: 0;}
	.time-day,.time-hour,.time-minute,.time-second{width: 4.54vw;height: 4.54vw;margin-top: 2.13vw;background: #fff;border-radius: 0.8vw;text-align: center;line-height: 4.54vw;color: #ff550a;}
	.time-day{margin-left: 1.86vw;}
	.time-text{margin-left: 1.06vw;margin-right: 2.4vw;}
	.time-target{margin: 0 1.33vw;}
	.live-bottom-title{height: 13.33vw;line-height: 12.26vw;padding: 0 4.26vw;font-size: 4.26vw;}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue